"use client";

import { useT } from "@/lib/i18n";

/** Editable diagrams start with a clear canvas; read-only shells explain access. */
export function CanvasEmptyState({
  /** Whether this editor exposes an add-parts control. */
  showPaletteHint = true,
}: {
  showPaletteHint?: boolean;
}) {
  const tr = useT();

  if (showPaletteHint) return null;

  return (
    <div className="absolute inset-0 z-10 flex items-center justify-center pointer-events-none">
      <div className="w-[min(480px,calc(100%-48px))] -mt-8 text-center">
        <h2 className="text-[length:var(--text-display-xs)] font-semibold tracking-tight leading-tight text-[var(--color-fg)]">
          {tr("canvas.empty.manual_title")}
        </h2>
        <p className="mt-1.5 text-[13px] leading-snug text-[var(--color-fg-muted)]">
          {tr("canvas.empty.read_only")}
        </p>
      </div>
    </div>
  );
}
